/**
 * The four verifications of the tab Abnahmeprotokoll in the order the tab shows them, as the API
 * enum `AcceptanceVerificationType`, and the project field of each state.
 */
export const ACCEPTANCE_VERIFICATION_TYPES = ['SUBSTRUCTURE', 'AC', 'DC', 'SCAFFOLDING'];

export const STATE_TYPE_BY_ACCEPTANCE_VERIFICATION_TYPE = {
  SUBSTRUCTURE: 'substructureVerificationState',
  AC: 'acVerificationState',
  DC: 'dcVerificationState',
  SCAFFOLDING: 'scaffoldingVerificationState',
};
